import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';
import { api, handleApiResponse } from '@/lib/api';
import { Kanban } from '@/types';

export const useAccessibleKanbans = () => {
  const { user } = useAuthStore();

  return useQuery({
    queryKey: ['accessible-kanbans', user?.id, user?.role],
    queryFn: async (): Promise<Kanban[]> => {
      if (!user) return [];
      
      // Usar endpoint específico que retorna kanbans acessíveis baseado em user_kanbans
      try {
        const response = await api.get('/user-kanbans/my-accessible');
        return handleApiResponse(response);
      } catch (error) {
        console.error('Erro ao buscar kanbans acessíveis:', error);
        // Fallback: retornar array vazio se houver erro
        return [];
      }
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
};
